<div class="jhm-modal-background">
  <div id="give-credits-modal" class="jhm-modal give-credits-modal">
    <div class="top-icons">
      @if (transferStep === 'INIT') {
        <div class="credit-give-icon">
          <img src="./assets/images/credit-give-blue.svg">
        </div>
        <img class="cancel-button" src="./assets/images/black-x.svg" (click)="cancel()">
      }
      @if (transferStep === 'TRANSFERRING') {
        <div class="orange-spinner">
          <img src="./assets/images/spinner-orange.svg">
        </div>
        <img class="cancel-button" src="./assets/images/black-x.svg" (click)="cancel()">
      }
      @if (transferStep === 'TRANSFERRED') {
        <div class="success">
          <img src="./assets/images/credits-success.svg">
        </div>
        <img class="cancel-button" src="./assets/images/black-x.svg" (click)="cancel()">
      }
    </div>
    @if (transferStep === 'INIT') {
      <div>
        <div class="description">
          <span class="give-credits">Give Credit.</span> Who would you like to give credit to? You have <span class="credit-count">{{userCredits | centsToDollars}} in credit.</span>
        </div>
        <div class="horizontal-line horizontal-line-give"></div>
        <mat-form-field appearance="outline" class="search">
          <input matInput [(ngModel)]="searchQuery" (ngModelChange)="this.searchQueryUpdate.next($event)" placeholder="Inmate Name" #input>
        </mat-form-field>
        @if ((!contacts || contacts?.length < 1) && searchQuery?.length > 0) {
          <div class="no-contacts">
            No contacts found
          </div>
        }
        @if (contacts?.length > 0) {
          <div class="contacts">
            @for (contact of contacts; track contact; let isFirst = $first; let isLast = $last) {
              <div class="line-item" [class.first]="isFirst" [class.last]="isLast">
                <div class="name-and-credits">
                  <div class="name">
                    {{contact.contactFirstName}} {{contact.contactLastName}}
                  </div>
                  <div class="credits" [class.warn]="contact.contactCredits <= 5">
                    {{contact.contactCredits | centsToDollars}}
                  </div>
                </div>
                @if (!contactIsAdded(contact.contactId)) {
                  <div class="add-contact">
                    <img src="./assets/images/add.svg" (click)="addContact(contact)">
                  </div>
                } @else {
                  <div class="added">
                    Added
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (addedContacts?.length < 1 && (!searchQuery || searchQuery?.length === 0)) {
          <div class="no-added-contacts">
            Search and add a contact to give credit.
          </div>
        }
        @if (addedContacts?.length > 0) {
          <div class="added-contacts">
            <div class="credits-to-give">
              Credit to Give
            </div>
            @for (addedContact of addedContacts; track addedContact; let isFirst = $first; let isLast = $last) {
              <div class="line-item" [class.first]="isFirst" [class.last]="isLast">
                <div class="name-and-credits">
                  <div class="name">
                    {{addedContact.contactFirstName}} {{addedContact.contactLastName}}
                  </div>
                  <div class="credits" [class.warn]="addedContact.contactCredits <= 5">
                    {{addedContact.contactCredits | centsToDollars}}
                  </div>
                </div>
                <div class="give-credits">
                  <img src="./assets/images/subtract.svg" (click)="subtractCreditsToUser(addedContact.contactId)">
                  <div>{{getCreditsGivingToUser(addedContact.contactId)}}</div>
                  <img src="./assets/images/add.svg" (click)="addCreditsToUser(addedContact.contactId)">
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (transferStep === 'TRANSFERRING') {
      <div>
        <div class="description">
          <span class="give-credits">Giving credit.</span> Hold on for just a moment...
        </div>
      </div>
    }
    @if (transferStep === 'TRANSFERRED') {
      <div>
        <div class="description">
          You're so generous! You just gave <span class="credits-given">{{givingCreditCount | centsToDollars}} in credit.</span>
        </div>
      </div>
    }
    @if (transferStep === 'INIT') {
      <footer class="filled">
        <button class="jhm-button" (click)="cancel()">Back</button>
        <button [class.disabled]="givingCreditCount < 1" class="jhm-button primary" (click)="giveCredits()">Give Credit</button>
      </footer>
    }
    @if (transferStep === 'TRANSFERRED') {
      <footer class="filled">
        <button class="jhm-button primary" (click)="cancel()">Done</button>
      </footer>
    }
  </div>
</div>